import {
    Box,
    Avatar
} from "@mui/material";
import React, { ReactNode } from "react";

interface StatusAvatarProps {
    bgcolor?: string;
    size?: 'small' | 'large';
    children: ReactNode;
}

export const StatusAvatar : React.FC<StatusAvatarProps> = ({ size = "small", bgcolor = 'success.main', children }: StatusAvatarProps) => {
    return (
        <Avatar
            sx={{
                bgcolor: bgcolor,
                borderRadius: .5,
                transform: "rotate(45deg)",
                width: size === "small" ? 28 : 35,
                height: size === "small" ? 28 : 35,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <Box
                sx={{
                    transform: "rotate(-45deg)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {children}
            </Box>
        </Avatar>
    );
};